import { inject } from '@angular/core';
import { SettingApiService } from '@shared/services';
import { TableConfig, PLACEHOLDER_FUNCTIONS } from '../generic-p-table.interfaces';

export const settingTableConfig = (): TableConfig => {
  const settingApiService = inject(SettingApiService);

  return {
    title: 'Quản lý tags',
    entityName: 'tag',
    service: settingApiService,
    method: 'getSettings',
    columns: [
      { field: 'code', header: 'Mã', width: 'min-w-[100px]', sortable: true, type: 'tag', tagColor: 'bgColor', tagTextColor: 'textColor' },
      { field: 'name', header: 'Tên', width: 'min-w-[150px]', sortable: true, type: 'text' },
      { field: 'type', header: 'Loại', width: 'min-w-[120px]', sortable: true, type: 'text' },
      { field: 'bgColor', header: 'Màu nền', width: 'min-w-[100px]', sortable: false, type: 'color' },
      { field: 'bgChildColor', header: 'Màu nền con', width: 'min-w-[100px]', sortable: false, type: 'color' },
      { field: 'textColor', header: 'Màu chữ', width: 'min-w-[100px]', sortable: false, type: 'color' }
    ],
    features: {
      virtualScroll: true,
      toolbar: true
    },
    actions: [
      {
        location: 'toolbar',
        useDefaultStyle: 'add',
        onClick: PLACEHOLDER_FUNCTIONS.OPEN_NEW
      },
      {
        location: 'row',
        useDefaultStyle: 'edit',
        onClick: PLACEHOLDER_FUNCTIONS.EDIT
      },
      {
        location: 'row',
        useDefaultStyle: 'delete',
        onClick: PLACEHOLDER_FUNCTIONS.DELETE,
        confirmMessage: 'Bạn có chắc chắn muốn xóa tag này?'
      }
    ]
  };
};

